/**
 * The body of one job PATCH from the board (`PATCH /api/jobs/:id`).
 *
 * Only the fields the caller set are sent. `assignmentReason` used to be
 * dropped here: the ask-before-assign prompt collected why the office put an
 * unapproved tech on a job, the board passed it along, and this body never
 * carried it, so the review flag never said "Office said: …".
 */
export interface PatchJobBodyInput {
    assignedTo?: string | null;
    scheduledStart?: string | null;
    scheduledEnd?: string | null;
    status?: string;
    force?: boolean;
    forceReason?: string;
    assignmentReason?: string;
    /** The placement stamp to guard on; null/undefined sends no guard. */
    ifDispatchChangedAt?: string | null;
    /** The office answered "book anyway" to a TECH_OUT refusal. */
    bookWhileOut?: boolean;
}

export function patchJobBody(v: PatchJobBodyInput): Record<string, unknown> {
    return {
        ...(v.assignedTo !== undefined && { assignedTo: v.assignedTo }),
        ...(v.scheduledStart !== undefined && { scheduledStart: v.scheduledStart }),
        ...(v.scheduledEnd !== undefined && { scheduledEnd: v.scheduledEnd }),
        ...(v.status && { status: v.status }),
        ...(v.force && { force: v.force }),
        ...(v.forceReason && { forceReason: v.forceReason }),
        ...(v.assignmentReason && v.assignmentReason.trim() && { assignmentReason: v.assignmentReason.trim() }),
        ...(v.ifDispatchChangedAt && { ifDispatchChangedAt: v.ifDispatchChangedAt }),
        ...(v.bookWhileOut && { bookWhileOut: true }),
    };
}
